import { useCallback } from "react";

import type { HotelNotificationSettingInput } from "@/lib/gql/__generated__/graphql";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";
import { useLoadingScreen } from "@/components/features/side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";

import { HOTEL_NOTIFICATION_SETTING_MUTATION } from "./schema";

type Props = {
	onResetViewModel: () => void;
};

export const useHotelNotificationSettingsMutation = ({ onResetViewModel }: Props) => {
	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();

	const { mutationFunc } = useCustomMutation(HOTEL_NOTIFICATION_SETTING_MUTATION);

	const onUpdateHotelNotificationSettings = useCallback(
		async (input: HotelNotificationSettingInput) => {
			showLoadingScreenCallback();

			const { errors } = await mutationFunc({ variables: { input } }).finally(() => {
				hideLoadingScreenCallback();
			});

			if (!errors) {
				notifyUserEventInfo({
					variant: "default",
					title: "通知設定を更新しました",
				});

				onResetViewModel();
			}
		},
		[mutationFunc, onResetViewModel, showLoadingScreenCallback, hideLoadingScreenCallback],
	);

	return {
		onUpdateHotelNotificationSettings,
	};
};
